import React, { useState, useMemo, useEffect } from "react";
import "../approvalMaster/ApprovalMasterList.scss";
import { useNavigate, useLocation } from "react-router-dom";
import Select from "react-select";
import FetchData, { GetOne, UpdateEntry } from "../../providers/dataProvider";
import SaveSuccessModel from "../../components/common/SaveSuccessModel";
import validation from "./validation";

// const style = {
// control: (base, state) => ({
//   ...base,
//   width: "100%",
//   minWidth: 0,
//   boxShadow: "none",
//   border: state.isDisabled
//     ? "1px solid #CED4DA"
//     : "1px solid #B4BABF",
//   backgroundColor: state.isDisabled
//     ? "#E9ECEF"
//     : "#F9FBFC",
//   fontSize: "14px",
//   minHeight: "35px",
//   height: "35px",
//   borderRadius: "6px",
//   color: state.isDisabled ? "#6C757D" : "#000000",
// }),
//   singleValue: (base, state) => ({
//     ...base,
//     color: state.isDisabled ? "#6C757D" : "#000000",
//   }),
//   placeholder: (base, state) => ({
//     ...base,
//     color: state.isDisabled ? "#6C757D" : base.color,
//   }),
//   dropdownIndicator: (base, state) => ({
//     ...base,
//     color: state.isDisabled ? "#6C757D" : base.color,
//   }),
//   indicatorSeparator: (base, state) => ({
//     ...base,
//     backgroundColor: state.isDisabled ? "#CED4DA" : base.backgroundColor,
//   }),
//   menuPortal: (base) => ({
//     ...base,
//     zIndex: 9999,
//   }),
//   menu: (base) => ({
//     ...base,
//     zIndex: 9999,
//   }),
// };

const style = {
  control: (base, state) => ({
    ...base,
    width: "100%",
    minWidth: 0,
    minHeight: "35px",
    height: "auto",
    boxShadow: "none",
    border: state.isDisabled
      ? "1px solid #CED4DA"
      : "1px solid #B4BABF",
    backgroundColor: state.isDisabled
      ? "#E9ECEF"
      : "#F9FBFC",
    fontSize: "14px",
    borderRadius: "6px",
  }),

  valueContainer: (base) => ({
    ...base,
    minWidth: 0,
    flex: 1,
    flexWrap: "wrap",
    overflow: "hidden",
    padding: "2px 8px",
  }),

  multiValue: (base) => ({
    ...base,
    maxWidth: "100%",
    flexShrink: 1,
    margin: "2px",
  }),

  multiValueLabel: (base) => ({
    ...base,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  }),

  multiValueRemove: (base) => ({
    ...base,
    flexShrink: 0,
  }),

  indicatorsContainer: (base) => ({
    ...base,
    flexShrink: 0,
  }),

  menuPortal: (base) => ({
    ...base,
    zIndex: 9999,
  }),
  menu: (base) => ({
    ...base,
    zIndex: 9999,
  }),
};

const selectMenuPortalTarget =
  typeof document !== "undefined" ? document.body : null;

const levelOptions = [
  { value: '1', label: '1' },
  { value: '2', label: '2' },
  { value: '3', label: '3' },
  { value: '4', label: '4' },
];

const approverTypeOptions = [
  { value: "TransactionRole", label: "Transaction Role" },
  { value: "SpecificUser", label: "Specific User" },
  { value: "SelectedUsersInRole", label: "Selected Users In Role" },
  { value: "RolePool", label: "Role Pool" },
];

const DisabledSelect = ({ placeholder = "Choose" }) => (
  <Select
    value={null}
    options={[]}
    className="basic-multi-select"
    styles={style}
    placeholder={placeholder}
    isDisabled
    menuPortalTarget={selectMenuPortalTarget}
    menuPosition="fixed"
  />
);

const getTransactionUserField = (approval = {}, role = {}) => {
  const formCode = approval.formCode || "";
  const formName = approval.formName || "";
  const roleName = role.label || role.name || role.roleName || "";
  const normalizedValue = `${formCode} ${formName} ${roleName}`.toLowerCase();

  if (
    normalizedValue.includes("factory") ||
    normalizedValue.includes("quotation") ||
    normalizedValue.includes("order") ||
    normalizedValue.includes("sales engineer") ||
    normalizedValue.includes("engineer")
  ) {
    return "SalesEngineerId";
  }

  return "SalesEngineerId";
};

const getUserLabel = (user = {}) =>
  [user.firstName, user.lastName].filter(Boolean).join(" ").trim() ||
  user.fullName ||
  user.FullName ||
  user.userName ||
  user.name ||
  "";

const EditApprovalMaster = () => {
  const { data: user } = FetchData("userprofile");
  const { data: userRole } = FetchData("userrole");
  const location = useLocation();
  const navigate = useNavigate()
  const { id } = location.state || {};

  useEffect(() => {
    window.dispatchEvent(new CustomEvent("pathfinderHeaderMetaChange", {
      detail: {
        pathname: location.pathname,
        title: location?.state?.row?.formName || "Approval Master",
        backTarget: { pathname: "/approval-master" },
      },
    }));

    return () => {
      window.dispatchEvent(new CustomEvent("pathfinderHeaderMetaChange", {
        detail: {
          pathname: location.pathname,
          clear: true,
        },
      }));
    };
  }, [location?.state?.row?.formName, location.pathname]);

  const [approvalDetails, setApprovalDetails] = useState(null);
  const [formValues, setFormValues] = useState([]);
  const [formErrors, setFormError] = useState([]);
  const [isSubmit, setIsSubmit] = useState(false);
  const [approvalMaster, setApprovalMaster] = useState([]);
  const [successShow, setSuccessShow] = useState(false);

  useEffect(() => {
    if (id) {
      GetOne("approval", { id }, setApprovalDetails);
    }
  }, [id]);

  const userOptions = useMemo(
    () =>
      (user || [])
        .filter((item) => item?.isActive === true)
        .map((item) => ({
          value: item.identityId || item.id,
          label: getUserLabel(item),
          roleId: item.roleId,
        }))
        .filter((item) => item.value && item.label)
        .filter(
          (item, index, options) =>
            options.findIndex((option) => String(option.value) === String(item.value)) === index
        ),
    [user]
  );

  const roleOptions = useMemo(
    () =>
      (userRole || [])
        .filter((role) => role?.isActive === true)
        .map((role) => ({
          value: role.id,
          label: role.name || role.roleName,
        }))
        .filter((item) => item.value && item.label)
        .filter(
          (item, index, options) =>
            options.findIndex((option) => String(option.value) === String(item.value)) === index
        ),
    [userRole]
  );

  const findRoleOption = (roleId, roleName = "") =>
    roleOptions.find((item) => String(item.value) === String(roleId)) ||
    (roleId ? { value: roleId, label: roleName || roleId } : null);

  const salesEngineerRole = useMemo(
    () =>
      roleOptions.find(
        (role) =>
          String(role.label || "")
            .replace(/\s+/g, "")
            .toLowerCase() === "salesengineer"
      ) || null,
    [roleOptions]
  );

  const findUserOption = (userId, fallbackLabel = "") =>
    userOptions.find((item) => String(item.value) === String(userId)) ||
    (userId ? { value: userId, label: fallbackLabel || userId } : null);

const HandleFormChange = (
  selectedOption,
  actionMeta,
  levelIndex,
  approverIndex = null
) => {
  setFormValues((prev) => {
    const updated = [...prev];

    if (approverIndex === null) {
      updated[levelIndex].level = selectedOption?.value
        ? selectedOption
        : {
            value: selectedOption?.label,
            label: selectedOption?.label,
          };
    } else {
      const approver = { ...updated[levelIndex].approvers[approverIndex] };
      const fieldName = actionMeta.name;

      approver[fieldName] = Array.isArray(selectedOption)
        ? selectedOption
        : selectedOption?.value
          ? selectedOption
          : selectedOption?.label
            ? {
                value: selectedOption.label,
                label: selectedOption.label,
              }
            : null;

      if (fieldName === "approverType") {
        const isTransactionRole = selectedOption?.value === "TransactionRole";

        approver.role = isTransactionRole ? salesEngineerRole : null;
        approver.roleId = isTransactionRole ? salesEngineerRole?.value || "" : "";
        approver.user = null;
        approver.userId = null;
        approver.userIds = [];
        approver.transactionUserField = isTransactionRole
          ? getTransactionUserField(approvalDetails?.data)
          : null;
      }

      if (fieldName === "role") {
        approver.roleId = selectedOption?.value || "";
        approver.user = null;
        approver.userId = null;
        approver.userIds = [];
        approver.transactionUserField =
          approver.approverType?.value === "TransactionRole"
            ? getTransactionUserField(approvalDetails?.data, selectedOption)
            : approver.transactionUserField;
      }

      if (fieldName === "user") {
        approver.userId = selectedOption || null;
        approver.roleId = selectedOption?.roleId || "";
      }

      updated[levelIndex].approvers[approverIndex] = approver;
    }

    return updated;
  });
};

  const handleCheckboxChange = (e, levelIndex, approverIndex) => {
    const { name, checked } = e.target;
    setFormValues((prev) => {
      const updated = [...prev];
      updated[levelIndex].approvers[approverIndex][name] = checked;
      return updated;
    });
  };

useEffect(() => {
  if (approvalDetails?.data?.levels?.length) {
    const mappedLevels = approvalDetails.data.levels.map((level, levelIndex) => ({
      level: {
        // Levels are a fixed workflow sequence, not a user-selectable value.
        value: String(levelIndex + 1),
        label: String(levelIndex + 1),
      },

      approvalMode: {
        value: level.approvalMode || "AnyOne",
        label: level.approvalMode || "AnyOne",
      },

      approvers: level.approvers.map((approver) => {
        const approverType = approver.approverType || "SpecificUser";
        const transactionRoleId = approver.roleId || "";
        const roleOption =
          approverType === "TransactionRole"
            ? salesEngineerRole
            : findRoleOption(transactionRoleId, approver.roleName);
        const specificUserId = approver.userId || approver.approverId || "";

        return {
        role: roleOption,

        user:
          approverType === "SpecificUser"
            ? findUserOption(specificUserId, approver.approverName)
            : null,

        roleId:
          approverType === "TransactionRole"
            ? salesEngineerRole?.value || ""
            : approver.roleId || "",

        approverType: {
          value: approverType,
          label:
            approverTypeOptions.find((option) => option.value === approverType)
              ?.label || approverType,
        },

        userId: findUserOption(specificUserId, approver.approverName),

        transactionUserField:
          approverType === "TransactionRole"
            ? getTransactionUserField(approvalDetails.data)
            : "",

        userIds: (approver.userIds?.length
          ? approver.userIds
          : (approverType === "SelectedUsersInRole" && approver.userId
            ? [approver.userId]
            : [])
        ).map((userId) => ({
          value: userId,
          label: findUserOption(userId, approver.userName)?.label || approver.userName || userId,
        })),

        isMandatory: approver.isMandatory ?? true,

        notifications: approver.notifyInSystem ?? false,

        mail: approver.notifyByEmail ?? false,
      }}),
    }));

    setFormValues(mappedLevels);
  }
}, [approvalDetails, roleOptions, salesEngineerRole, userOptions]);

  const handleAddNewLevel = () => {
  setFormValues((prev) => {
    if (prev.length >= levelOptions.length) {
      return prev;
    }

    const nextLevelNo = prev.length + 1;

    return [
      ...prev,
      {
        level: {
          value: String(nextLevelNo),
          label: String(nextLevelNo),
        },
        approvers: [
          {
            approverType: approverTypeOptions[1],
            role: null,
            roleId: "",
            user: null,
            userId: null,
            userIds: [],
            transactionUserField: null,
            notifications: false,
            mail: false,
          },
        ],
      },
    ];
  });

  setFormError((prev) => {
    if (prev.length >= levelOptions.length) {
      return prev;
    }

    return [
      ...prev,
      {
        level: "",
        approvers: [
          {
            user: "",
          },
        ],
      },
    ];
  });
};

  const HandleFormSubmit = (e) => {
    e.preventDefault();

    const errors = validation(formValues);
    setFormError(errors);

    const hasErrors = errors.some((levelError) => {
      if (Object.keys(levelError).length > 0) {
        if (levelError.level) return true;

        if (
          levelError.approvers &&
          levelError.approvers.some((a) => Object.keys(a).length > 0)
        ) {
          return true;
        }
      }
      return false;
    });

    if (!hasErrors) {
      setIsSubmit(true);
    }
  };

  useEffect(() => {
    const submitProduct = async () => {
      if (isSubmit) {
        const hasErrors = formErrors.some((levelError) => {
          if (levelError.level) return true;
          if (
            levelError.approvers &&
            levelError.approvers.some((a) => Object.keys(a).length > 0)
          ) {
            return true;
          }
          return false;
        });

        if (!hasErrors) {

          try {

          const payload = {
            formId: approvalDetails?.data?.formId || id || 0,

            levels: formValues.map((level, levelIndex) => {
              const existingLevel =
                approvalDetails?.data?.levels?.[levelIndex];

              return {
                id: existingLevel?.id || 0,

                levelNo: levelIndex + 1,

                approvalMode:
                  level.approvalMode?.value ||
                  existingLevel?.approvalMode ||
                  "AnyOne",

                isActive:
                  existingLevel?.isActive ?? true,

                approvers: level.approvers.map(
                  (approver, approverIndex) => {
                    const existingApprover =
                      existingLevel?.approvers?.[approverIndex];

                    const approverType =
                      approver.approverType?.value ||
                      existingApprover?.approverType ||
                      "SpecificUser";

                    const selectedSpecificUserRoleId =
                      approver.user?.roleId || approver.userId?.roleId || "";
                    const roleId =
                      approverType === "TransactionRole"
                        ? salesEngineerRole?.value || approver.roleId || ""
                        : approverType === "SpecificUser"
                          ? selectedSpecificUserRoleId || approver.roleId || ""
                          : approver.role?.value ||
                            approver.roleId ||
                            existingApprover?.roleId ||
                            "";

                    const specificUserId =
                      approver.user?.value ||
                      approver.userId?.value ||
                      existingApprover?.userId ||
                      "";

                    const selectedUserIds =
                      approver.userIds?.map((item) => item.value) ||
                      existingApprover?.userIds ||
                      [];

                    const approverIdByType = {
                      // Transaction roles are resolved from the configured role
                      // (Sales Engineer), not a stored approver or user record.
                      TransactionRole: "",
                      SpecificUser: specificUserId,
                      SelectedUsersInRole: roleId,
                      RolePool: roleId,
                    };

                    return {
                      id: existingApprover?.id || 0,

                      approverId:
                        approverType === "TransactionRole" ||
                        approverType === "RolePool" ||
                        approverType === "SelectedUsersInRole"
                          ? ""
                          : approverIdByType[approverType] ||
                        existingApprover?.approverId ||
                        "",

                      approverType,

                      roleId,

                      userId:
                        approverType === "SpecificUser"
                          ? specificUserId
                          : approverType === "SelectedUsersInRole"
                            ? selectedUserIds[0] || ""
                            : "",

                      transactionUserField:
                        approverType === "TransactionRole"
                          ? getTransactionUserField(approvalDetails?.data)
                          : "",

                      isMandatory:
                        approver.isMandatory ??
                        existingApprover?.isMandatory ??
                        true,

                      notifyInSystem:
                        approver.notifications ?? false,

                      notifyByEmail:
                        approver.mail ?? false,

                      userIds:
                        approverType === "SelectedUsersInRole"
                          ? selectedUserIds
                          : [],
                    };
                  }
                ),
              };
            }),
          };

            await UpdateEntry(
              "approval",
              payload,
              setApprovalMaster,
              "Approval updated successfully",
              "Approval update failed"
            );

          } catch (error) {
            console.error(error?.message || error);
          } finally {
            setIsSubmit(false);
          }
        } else {
          setIsSubmit(false);
        }
      }
    };

    submitProduct();
  }, [isSubmit, formErrors, formValues, salesEngineerRole]);

  useEffect(() => {
    if (approvalMaster?.status === 200) {
      setSuccessShow(true);
    }
  }, [approvalMaster]);

  const SuccessDoneClick = () => {
    setSuccessShow(false);
    navigate("/approval-master");
  };

  const HandleClose = () => {
    navigate('/approval-master')
  }

  const handleDeleteApprover = (levelIndex, approverIndex) => {
  setFormValues((prev) => {
    const updated = [...prev];

    updated[levelIndex].approvers = updated[levelIndex].approvers.filter(
      (_, index) => index !== approverIndex
    );

    if (updated[levelIndex].approvers.length === 0) {
      updated.splice(levelIndex, 1);
    }

    return updated;
  });

  setFormError((prev) => {
    const updated = [...prev];

    if (updated[levelIndex]?.approvers) {
      updated[levelIndex].approvers = updated[levelIndex].approvers.filter(
        (_, index) => index !== approverIndex
      );
    }

    if (updated[levelIndex]?.approvers?.length === 0) {
      updated.splice(levelIndex, 1);
    }

    return updated;
  });
};

  const hasAllApproverTypes = useMemo(() => {
    const selectedTypes = new Set(
      formValues.flatMap((level) =>
        (level?.approvers || []).map((approver) => approver?.approverType?.value)
      ).filter(Boolean)
    );

    return approverTypeOptions.every((type) => selectedTypes.has(type.value));
  }, [formValues]);

  const canAddNewLevel =
    formValues.length < levelOptions.length && !hasAllApproverTypes;

  const getUsersByRole = (roleId) =>
    userOptions.filter(
      (item) => String(item.roleId) === String(roleId)
    );

  const renderApproverControls = (approver, levelIndex, approverIndex) => {
    const type = approver.approverType?.value || "SpecificUser";
    const roleId = approver.role?.value || approver.roleId;
    const roleUsers = getUsersByRole(roleId);

    if (type === "TransactionRole") {
      return (
        <>
          <td>
            <DisabledSelect placeholder="Sales Engineer" />
          </td>
          <td>
            <DisabledSelect placeholder="Quotation sales engineer" />
          </td>
        </>
      );
    }

    if (type === "SpecificUser") {
      return (
        <>
          <td>
            <DisabledSelect />
          </td>
          <td>
            <Select
              name="user"
              value={approver.user}
              onChange={(opt, meta) =>
                HandleFormChange(opt, meta, levelIndex, approverIndex)
              }
              options={userOptions}
              className="basic-multi-select"
              styles={style}
              placeholder="Choose"
              menuPortalTarget={selectMenuPortalTarget}
              menuPosition="fixed"
            />
            {formErrors[levelIndex]?.approvers?.[approverIndex]?.user && (
              <p className="form-error">
                {formErrors[levelIndex].approvers[approverIndex].user}
              </p>
            )}
          </td>
        </>
      );
    }

    if (type === "SelectedUsersInRole") {
      return (
        <>
          <td>
            <Select
              name="role"
              value={approver.role}
              onChange={(opt, meta) =>
                HandleFormChange(opt, meta, levelIndex, approverIndex)
              }
              options={roleOptions}
              className="basic-multi-select"
              styles={style}
              placeholder="Choose"
              menuPortalTarget={selectMenuPortalTarget}
              menuPosition="fixed"
            />
            {formErrors[levelIndex]?.approvers?.[approverIndex]?.role && (
              <p className="form-error">
                {formErrors[levelIndex].approvers[approverIndex].role}
              </p>
            )}
          </td>
          <td>
            <Select
              isMulti
              name="userIds"
              value={approver.userIds || []}
              onChange={(opt, meta) =>
                HandleFormChange(opt || [], meta, levelIndex, approverIndex)
              }
              options={roleUsers}
              className="basic-multi-select"
              styles={style}
              placeholder="Choose"
              isDisabled={!roleId}
              menuPortalTarget={selectMenuPortalTarget}
              menuPosition="fixed"
            />
            {formErrors[levelIndex]?.approvers?.[approverIndex]?.userIds && (
              <p className="form-error">
                {formErrors[levelIndex].approvers[approverIndex].userIds}
              </p>
            )}
          </td>
        </>
      );
    }

    return (
      <>
        <td>
          <Select
            name="role"
            value={approver.role}
            onChange={(opt, meta) =>
              HandleFormChange(opt, meta, levelIndex, approverIndex)
            }
            options={roleOptions}
            className="basic-multi-select"
            styles={style}
            placeholder="Choose"
            menuPortalTarget={selectMenuPortalTarget}
            menuPosition="fixed"
          />
          {formErrors[levelIndex]?.approvers?.[approverIndex]?.role && (
            <p className="form-error">
              {formErrors[levelIndex].approvers[approverIndex].role}
            </p>
          )}
        </td>
        <td>
          <DisabledSelect />
        </td>
      </>
    );
  };

  return (
    <div className="container-fluid edit-approval-master-sec">
      {/* <!-- add-new-sec starts --> */}
      <div className="card">
        <div className="card-body">
          <div className="card">
            <div className="card-header">
              <h2>Approval configuration</h2>
            </div>
            <div className="card-body">
              {/* <!-- add-new-sec ends --> */}
              {/* approvals-sec start */}
              <section className="approvals-sec mt-2">
                <div className="row">
                  <div className="col-12">
                    {/* <!-- table-sec starts --> */}
                    <section className="table-sec">
                      <div className="row">
                        <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                          <div className="table-responsive my-3 approval-table-responsive">
                            <table className="table table-borderless approval-config-table">
                              <thead>
                                <tr>
                                  <th>Levels</th>
                                  <th>Type</th>
                                  <th>User Role</th>
                                  <th>User List</th>
                                  <th className="w-15">Notifications</th>
                                  <th className="w-15">Mail</th>
                                  <th className="text-right"></th>
                                </tr>
                              </thead>
                              <tbody>
                                {formValues.map((level, levelIndex) =>
                                  level.approvers.map((approver, approverIndex) => (
                                    <tr key={`${levelIndex}-${approverIndex}`}>
                                      <td>
                                        <span className="approval-level-number">{levelIndex + 1}</span>
                                        {formErrors[levelIndex]?.level && (
                                          <p className="form-error">{formErrors[levelIndex].level}</p>
                                        )}

                                      </td>
                                      <td>
                                        <Select
                                          name="approverType"
                                          value={approver.approverType || approverTypeOptions[1]}
                                          onChange={(opt, meta) =>
                                            HandleFormChange(opt, meta, levelIndex, approverIndex)
                                          }
                                          options={approverTypeOptions}
                                          className="basic-multi-select"
                                          styles={style}
                                          placeholder="Choose"
                                          menuPortalTarget={selectMenuPortalTarget}
                                          menuPosition="fixed"
                                        />
                                      </td>
                                      {renderApproverControls(approver, levelIndex, approverIndex)}
                                      <td className="w-15">
                                        <div className="form-group d-flex align-items-center">

                                          <input
                                            type="checkbox"
                                            name="notifications"
                                            checked={approver.notifications}
                                            onChange={(e) => handleCheckboxChange(e, levelIndex, approverIndex)}
                                          />
                                        </div>
                                      </td>
                                      <td className="w-15">
                                        <div className="form-group d-flex align-items-center">
                                          <input
                                            type="checkbox"
                                            name="mail"
                                            checked={approver.mail}
                                            onChange={(e) => handleCheckboxChange(e, levelIndex, approverIndex)}
                                          />
                                        </div>
                                      </td>

                                      <td className="text-right">
                                        <span>
                                         <i
                                            className="far fa-trash-alt mr-2"
                                            title="Delete"
                                            onClick={() =>
                                              handleDeleteApprover(levelIndex, approverIndex)
                                            }
                                            style={{ cursor: "pointer" }}
                                          ></i>
                                        </span>
                                        <span className="d-none">
                                          <i
                                            className="fas fa-plus"
                                            title="Delete"
                                          ></i>
                                        </span>
                                      </td>
                                    </tr>
                                  ))
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </section>
                    {/* <!-- table-sec end --> */}
                  </div>
                  <hr/>
                  {canAddNewLevel && (
                    <div className="col-12">
                      <div className="d-flex justify-content-end">
                        <button className="btn add-level-btn" onClick={handleAddNewLevel}>Add new level</button>
                      </div>
                    </div>
                  )}
                </div>
              </section>
              {/* approvals-sec end */}
            </div>
          </div>
            <div className="row mt-4 mb-3">
              <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div className="save-btns d-flex justify-content-end">
                  <button className="btn cancel-btn" onClick={HandleClose}>Cancel</button>
                  <button
                    className="btn save-btn"
                    onClick={(e) => HandleFormSubmit(e)}
                    disabled={isSubmit}
                  >
                    {isSubmit ? "Saving..." : "Save"}
                  </button>
                </div>
              </div>
            </div>
        </div>
      </div>
      <SaveSuccessModel
        show={successShow}
        createMsg={approvalMaster}
        setShow={setSuccessShow}
        SuccessDoneClick={SuccessDoneClick}
      />
    </div>
  );
};

export default EditApprovalMaster;
